const vouchersServiceMixin = {
    data: function () {
        return {
            VOUCHERS_BASE: '/api/VouchersApi/'
        }
    },
    methods: {
        applyPromoCode: function (data) {
            return this.post(this.VOUCHERS_BASE, 'ApplyPromoCode', data);
        },
        removePromoCode: function (data) {
            return this.get(this.VOUCHERS_BASE, 'RemovePromoCode', data);
        }
    }
}